import React, { useState, useContext, useEffect } from "react";
import { AuthContext } from "../../../context/auth";
import { Mensaje } from "../../mensajes2";
import { Dimmer } from "../../spinner";
import ValidarUsuario from "../../comun/modalValidarUsuario";
import CajaIngresos from "../caja/cajaingresos";
import { ReversarTransaccion } from "../caja/modalReversarTransaccion";
import CerrarAbrirMes from "../caja/modalAbrirCerrarMes";
import TablaMovimientosBancos from "../caja/notasCredito";
import ImpModalCaja from "../caja/modalImpCaja";
import CajaIngresos2 from "../caja/cajaImgresos2";
import Reactivacion from "./reactivacionN";
import Menu from "../../comun/Menu/Menu";
import Item from "../../comun/Menu/Item";
import DasboardCaja from "../caja/grafiacasCaja";
import Axios from "axios";
import { ImpFacturaEmitidas } from "./modalImpFacturaEmitidas";

function MenuPrincipalFacturacion() {
  const { user } = useContext(AuthContext);
  const [show, setShow] = useState(false);

  const [mostrar, setMostrar] = useState(false);
  const [mostrarImp, setMostrarImp] = useState(false);
  const [activate, setActivate] = useState(false);

  const [operacion] = useState();
  const [mostrarUsuario, setMostrarUsuario] = useState(false);
  const [mostrarCerrarAbrir, setMostrarCerrarAbrir] = useState(false);
  const [tipoCaja] = useState();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [fechaSistema, setFechaSistema] = useState(
    localStorage.getItem("fechasistema"),
  );
  const [tabla, setTabla] = useState(0);
  var op = require("../../../../src/modulos/datos");
  const token = localStorage.getItem("jwtToken");

  const seleccionarImpresora = (printer) => {
    let campos = "*";
    let nomtab = "impresoras";
    let condi = `descripcion = '${printer}' and status = 1`;
    let orden = "1";
    let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;
    setActivate(true);
    console.log(endpoint);
    Axios.get(endpoint, {
      headers: {
        "x-access-token": `${token}`,
      },
    })
      .then(function (response) {
        if (response.status === 200) {
          let impresora = [];
          for (let i = 0; i < response.data.length; i++) {
            impresora.push({
              message: "imprimir",
              server: response.data[i].descripcion.toLowerCase(),
              impresora: response.data[i].modelo,
              idfactura: 0,
              fecha: "",
              tipo: "",
              copias: 1,
              papel: response.data[i].papel,
              tipopago: "",
              socket: true,
            });
          }
          console.log(impresora);
          localStorage.setItem("impresora", JSON.stringify(impresora));
        }
        setActivate(false);
      })
      .catch(function (error) {
        console.log(error);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(function () {
        setActivate(false);
      });
  };
  useEffect(() => {
    let obj = JSON.parse(localStorage.getItem("post"));
    setFechaSistema(obj.fechasistema);
    seleccionarImpresora(obj.nameprint);
    if (obj != null) {
      setFechaSistema(obj.fechasistema);
      var nanio = [];
      var aini = parseInt(obj.anioactu) - 7;
      var afin = parseInt(obj.anioactu);
      for (let i = 1; i <= afin - aini; i++) {
        nanio.push({ anio: aini + i });
      }
    } else {
    }
  }, []);

  const modalReversarTransaccion = () => {
    setMostrar(false);
  };

  const cerrarAbrirCaja = () => {
    setMostrarUsuario(false);
    setMostrarCerrarAbrir(true);
  };

  const actualizacionItem = {
    title: "Facturar",
    icon: "fas fa-credit-card me-2",
    drop: [
      {
        title: "Facturación Integral",
        itemClickValue: 1,
        icon: "fas fa-border-all me-2",
      },
    ],
  };
  const imprimirItem = {
    title: "At. al Contribuyente",
    icon: "fas fa-user-check me-2",
    drop: [
      {
        title: "Generar Pagos/Número",
        itemClickValue: 3,
        icon: "fas fa-money-bill me-2",
      },
      {
        title: "Reactivar Número",
        itemClickValue: 4,
        icon: "fab fa-creative-commons-sa me-2",
      },
      {
        title: "Reasignar Número",
        itemClickValue: 5,
        icon: "fas fa-user-check me-2",
      },
    ],
  };
  const reportes = {
    title: "Imprimir",
    icon: "fa fa-print me-2",
    drop: [
      {
        title: "Listado de Facturas Emitidas",
        icon: "far fa-file-powerpoint me-2",
        itemClickValue: 99,
      },
      {
        title: "Listado de Facturas por Cobrar",
        icon: "far fa-file-powerpoint me-2",
        itemClickValue: 98,
      },
      {
        title: "Listado de Facturas Cobradas",
        icon: "far fa-file-powerpoint me-2",
        itemClickValue: 97,
      },
      {
        title: "Listado de Facturas Anuladas",
        icon: "far fa-file-powerpoint me-2",
        itemClickValue: 96,
      },
      // {
      //   title: "Listado de Facturas por Tipo Impuesto",
      //   icon: "far fa-file-powerpoint me-2",
      //   itemClickValue: 95,
      // },
    ],
  };
  const configuracionItem = {
    title: "Configuración",
    icon: "fas fa-print me-2",
    drop: [
      {
        title: "Configuración General",
        itemClickValue: 10,
        icon: "fas fa-users-cog fa-fw me-2",
      },
      {
        title: "usuarios",
        itemClickValue: 4,
        icon: "fas fa-users-cog fa-fw me-2",
      },
    ],
  };
  useEffect(() => {
    if (tabla.toString() === "95") {
      let condicion = "true";
      let titulo = "";
      window.open(
        op.reportes +
          "/factura?reporte=FacTipoIngreso" +
          `&CONDICION=${condicion}` +
          `&TIT_RGO1=${titulo}&TIT_RGO3=Facturas Por Tipo de Ingreso`,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );
      setShow(false);
      setTabla(0);
    }
  }, [tabla]);
  const vista = {
    0: <DasboardCaja />,
    1: <CajaIngresos2 />,
    2: <TablaMovimientosBancos />,
    3: <CajaIngresos />,
    4: (
      <Reactivacion
        menu={() => {
          setTabla(0);
        }}
        llamado={1}
      />
    ),
    5: (
      <Reactivacion
        menu={() => {
          setTabla(0);
        }}
        llamado={2}
      />
    ),
    99: (
      <ImpFacturaEmitidas
        show={show}
        onHideCancela={() => {
          setShow(false);
          setTabla(0);
        }}
        tipo="emitidas"
      />
    ),
    98: (
      <ImpFacturaEmitidas
        show={show}
        onHideCancela={() => {
          setShow(false);
          setTabla(0);
        }}
        tipo="porCobrar"
      />
    ),
    97: (
      <ImpFacturaEmitidas
        show={show}
        onHideCancela={() => {
          setShow(false);
          setTabla(0);
        }}
        tipo="cobradas"
      />
    ),
    96: (
      <ImpFacturaEmitidas
        show={show}
        onHideCancela={() => {
          setShow(false);
          setTabla(0);
        }}
        tipo="anuladas"
      />
    ),
  };

  const menu = user ? (
    <div>
      <Menu fechaSistema={fechaSistema} op={op}>
        <Item item={actualizacionItem} setTabla={setTabla} setShow={setShow} />
        <Item item={imprimirItem} setTabla={setTabla} setShow={setShow} />
        <Item item={reportes} setTabla={setTabla} setShow={setShow} />
        <Item item={configuracionItem} setTabla={setTabla} setShow={setShow} />
        <a
          href="/haciendaMunicipal"
          className="list-group-item list-group-item-action bg-transparent text-danger fw-bold"
        >
          <i className="fas fa-power-off me-2" />
          Salir
        </a>
      </Menu>
      {vista[tabla]}
      <ImpModalCaja
        operacion={operacion}
        show={mostrarImp}
        onHideCancelar={() => {
          setMostrarImp(false);
        }}
      />

      <ValidarUsuario
        show={mostrarUsuario}
        onHideCancela={() => {
          setMostrarUsuario(false);
        }}
        onHideConfirmar={cerrarAbrirCaja}
        llamado={1}
      />

      <CerrarAbrirMes
        show={mostrarCerrarAbrir}
        onHideCancela={() => {
          setMostrarCerrarAbrir(false);
        }}
        llamado={1}
        operacion={tipoCaja}
      />

      <Dimmer active={activate} inverted></Dimmer>

      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <ReversarTransaccion
        show={mostrar}
        onHideCancela={modalReversarTransaccion}
      />
    </div>
  ) : (
    ""
  );

  return menu;
}
export default MenuPrincipalFacturacion;
